<div class="reset-password-container">
  <!-- Header -->
  <header class="header">
    <div class="logo">
      <img src="assets/branding/flit-core-logo-light.svg" alt="Flit Core" class="logo-image">
    </div>
  </header>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Illustration -->
    <div class="illustration">
        <i class="fa-solid fa-key icon-key"></i>
    </div>

    <!-- Heading -->
    <h1 class="heading">{{ pageTitle }}</h1>
    
    <!-- Instructions -->
    <p class="instructions">{{ pageInstructions }}</p>

    <!-- Password Form -->
    <form class="password-form" (ngSubmit)="resetPassword()">
      <!-- New Password -->
      <div class="input-group">
        <div class="password-input-container">
          <input 
            [type]="showNewPassword ? 'text' : 'password'" 
            id="newPassword"
            class="password-input" 
            [(ngModel)]="newPassword"
            name="newPassword"
            placeholder="Digite a nova senha"
            required>
          <button 
            type="button" 
            class="toggle-password" 
            (click)="togglePasswordVisibility('newPassword')">
            <i class="fa-solid" [class.fa-eye]="!showNewPassword" [class.fa-eye-slash]="showNewPassword"></i>
          </button>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="input-group">
        <div class="password-input-container">
          <input 
            [type]="showConfirmPassword ? 'text' : 'password'" 
            id="confirmPassword"
            class="password-input" 
            [(ngModel)]="confirmPassword"
            name="confirmPassword"
            placeholder="Confirme a nova senha"
            required>
          <button 
            type="button" 
            class="toggle-password" 
            (click)="togglePasswordVisibility('confirmPassword')">
            <i class="fa-solid" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
          </button>
        </div>
      </div>

      <!-- Error messages are shown via the global error modal -->

      <!-- Reset Button -->
     <div style="display: flex; justify-content: center;">
      <button type="submit" class="reset-button" [disabled]="!isFormValid() || isLoading">
        <span *ngIf="!isLoading">Alterar Senha</span>
        <span *ngIf="isLoading">Alterando...</span>
      </button>
     </div>
    </form>

    <!-- Back to Login Link -->
    <a href="#" class="back-link" (click)="goBack()">
      ← Voltar ao Login
    </a>
  </main>

  <!-- Footer -->
  <footer class="footer">
    <span class="copyright">Copyright©2025</span>
    <a href="#" class="privacy-policy">Sistema de Gestão</a>
  </footer>
</div>
